export default {
  lineNumberColor: `#d1d9e1`,
  lineNumberBgColor: `#474949`,
  backgroundColor: `#474949`,
  textColor: `#d1d9e1`,
  substringColor: `#f99157`,
  keywordColor: `#cc99cc`,
  attributeColor: `#81a2be`,
  selectorAttributeColor: `#cc99cc`,
  docTagColor: `#8abeb7`,
  nameColor: `#b5bd68`,
  builtInColor: `#b5bd68`,
  literalColor: `#cc99cc`,
  bulletColor: `#f99157`,
  codeColor: `#d1d9e1`,
  additionColor: `#cc99cc`,
  regexpColor: `#8abeb7`,
  symbolColor: `#f99157`,
  variableColor: `#ffcc66`,
  templateVariableColor: `#ffcc66`,
  linkColor: `#f99157`,
  selectorClassColor: `#d1d9e1`,
  typeColor: `#cc99cc`,
  stringColor: `#8abeb7`,
  selectorIdColor: `#ffcc66`,
  quoteColor: `#969896`,
  templateTagColor: `#d1d9e1`,
  deletionColor: `#dc322f`,
  titleColor: `#b5bd68`,
  sectionColor: `#b5bd68`,
  commentColor: `#969896`,
  metaKeywordColor: `#d1d9e1`,
  metaColor: `#f99157`,
  functionColor: `#d1d9e1`,
  numberColor: `#f99157`,
}
